var _circle, _path, _circle2, _circle3, _path2, _path3, _path4, _rect, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyListing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.758,
    cy: 65.4338,
    r: 60.3205,
    fill: "#E9F0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1992 110.972V24.5703H108.32V110.969C97.729 120.178 83.8946 125.753 68.7581 125.753C53.6229 125.753 39.7896 120.179 29.1992 110.972Z",
    fill: "#256AF5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.2205,
    cy: 31.6258,
    r: 15.158,
    fill: "#256AF5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.2256,
    cy: 31.626,
    r: 6.03808,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4766 82.2186L127.742 75.1621V134.887H84.4766V82.2186Z",
    fill: "#6CCC93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.564 131.895H79.6602",
    stroke: "#6CCC93",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5938 46.7842H89.9468M42.5938 59.8615H84.6491M42.5938 72.9388H94.9226M42.5938 86.018H77.0303",
    stroke: "white",
    strokeWidth: 3.33333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.0859,
    y: 115.711,
    width: 14.0449,
    height: 19.1757,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8984 92.4902H102.594M109.629 92.4902H121.324",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8984 103.02H102.594M109.629 103.02H121.324",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyListing);
export default __webpack_public_path__ + "static/media/company-listing.f348838d57f45a06aece1b859f09ab94.svg";
export { ForwardRef as ReactComponent };